<template>
  <q-layout view="hHh lpR fFf" style="height: 100vh" class="bg-neutral-5" :class="{'mobile': !$isDesktop}">
    <page-header show-on-mobile />
    <q-page-container>
      <component :is="pageComponent" v-bind="pageData" />
    </q-page-container>
    <page-footer />
  </q-layout>
</template>

<script>
import PageHeader from './PageHeader'
import PageFooter from './PageFooter'

export default {
  props: {
    pageComponent: {
      type: String,
      required: true,
    },
    pageData: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  components: {
    PageHeader,
    PageFooter,
  },
}
</script>
